import styled from '@emotion/styled'
import { Button, Col } from 'components/patterns'
import { stylesIf } from 'utils/styles'

export const StyledFilterItemContainer = styled.div((props) => {
  const { isHorizontalLayout } = props

  return `
    display: flex;
    flex-direction: ${isHorizontalLayout ? `row` : `column`};
    justify-content: space-around;
    margin-top: 5px;
    margin-bottom: -4px;
`
})

export const StyledModuleFilterCol = styled(Col)((props) => {
  const { isHorizontalLayout } = props
  const horizontalStyles = `
    padding-right: 9px !important;
    margin-left: 7px;
  `
  return `
    ${stylesIf(isHorizontalLayout, horizontalStyles)}
  `
})

export const ModuleLabel = styled.label((props) => {
  const { isHorizontalLayout } = props
  const horizontalStyles = `
    margin-right: 7px;
  `
  return `
    ${stylesIf(isHorizontalLayout, horizontalStyles)}
  `
})

export const StyledStatusFilterCol = styled(Col)((props) => {
  const { isHorizontalLayout, noSpacing } = props
  const horizontalStyles = `
    padding: 90px !important;
  `
  return `
    ${stylesIf(isHorizontalLayout, horizontalStyles)}
    ${stylesIf(noSpacing, `padding: 0px !important;`)}
  `
})

export const StyledButtonCol = styled(Col)((props) => {
  const { isHorizontalLayout } = props
  const horizontalStyles = `
    padding-left: 0 !important;
    display: flex !important;
    justify-content: flex-end;
    gap: 8px;
  `
  return `
    margin-top: 10px;
    margin-bottom: 20px;
    ${stylesIf(isHorizontalLayout, horizontalStyles)}
  `
})

export const StyledButton = styled(Button)(
  ({ float }) => `
  margin-bottom: 1px !important;
  margin-left: 2px !important;
  ${stylesIf(float, `float: ${float}`)}
`
)
